import React, { useEffect, useRef } from "react";
import { sendLead, sendActiveTrail } from "../../Services/api";
import "./RegisterForm.scss";
import { Urls, ENV } from "../../Services/urls";
import { GA_Push } from "../../Services/analytics";

const RegisterForm = () => {
  const nameInput = useRef();
  const emailInput = useRef();
  const checkboxInput = useRef();
  const phoneInput = useRef();
  const emailRegex = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  const phoneRegex = /^[0-9]{2,3}(?:-?)[0-9]{3}(?:-?)[0-9]{4}$/;

  const loadGoogleRecaptcha = () => {
    if (Urls.environment !== ENV.LOCAL) {
      (() => {
        if (window.document.getElementById("GoogleRecap")) return;

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "GoogleRecap";
        script.async = 1;
        script.src = "https://www.google.com/recaptcha/api.js";

        document.getElementsByTagName("head")[0].appendChild(script);
      })();
    }
  };
  useEffect(() => {
    loadGoogleRecaptcha();
    window.sendFormViaCaptcha = Submit;
  }, []);

  const handleSubmitClick = () => {
    // if (nameInput.current.value == "") {
    //   alert("נדרש למלא שם מלא");
    //   GA_Push("Send Form", "Fail");

    //   return;
    // }
    if (!emailRegex.test(emailInput.current.value)) {
      alert("נדרש למלא מייל תקין");
      GA_Push("Send Form", "Fail");

      return;
    }
    // if (!phoneRegex.test(phoneInput.current.value)) {
    //   alert("נדרש למלא מספר טלפון תקין");
    //   GA_Push("Send Form", "Fail");

    //   return;
    // }
    if (!checkboxInput.current.checked) {
      alert("נדרש להסכים לתנאים");
      GA_Push("Send Form", "Fail");

      return;
    }

    Urls.environment !== ENV.LOCAL ? window.grecaptcha.execute() : Submit();
  };
  const Submit = () => {
    if (Urls.environment !== ENV.LOCAL) {
      window.grecaptcha.reset();
    }
    // sendLead({
    //   name: nameInput.current.value,
    //   email: emailInput.current.value,
    //   phone: phoneInput.current.value,
    // });
    sendActiveTrail({
      email: emailInput.current.value
    });

  };

  return (
    <div className="form-container">
      {/* <div className="input-wrapper">
        <input type="text" placeholder="שם מלא" ref={nameInput}></input>
      </div>
      <div className="input-wrapper">
        <input type="text" placeholder="מספר טלפון" ref={phoneInput}></input>
      </div> */}
      <div className="input-wrapper">
        <input type="text" placeholder='דוא"ל' ref={emailInput}></input>
      </div>

      <div className="terms">
        <input
          type="checkbox"
          name="terms-checkbox"
          className="styled"
          ref={checkboxInput}
        ></input>
        <label
          htmlFor="terms-checkbox"
          onClick={() =>
            (checkboxInput.current.checked = !checkboxInput.current.checked)
          }
        >
          אני מסכים/ה
          <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html">
            לתנאי שימוש
          </a>
          ,
          <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html">
            ולמדיניות הפרטיות
          </a>
          ומאשר/ת קבלת הודעות תפעוליות ו/או חומר פרסומי מ +ynet בדוא"ל ו/או במסרוני SMS לפרטים שנמסרו.
        </label>
      </div>
      <button type="button" onClick={handleSubmitClick}>
        שלח
        <div
          className="g-recaptcha"
          data-callback="sendFormViaCaptcha"
          data-size="invisible"
          data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
        ></div>
      </button>
          <div className="disclaimer">כתבות +ynet והמהדורה הדיגיטלית של ידיעות אחרונות זמינות למנויי +ynet בלבד באפליקציית ynet</div>
    </div>
  );
};

export default RegisterForm;
